interface EqualHousingLogoProps {
  className?: string;
  /** Pixel height of the mark. Width scales automatically. */
  size?: number;
  showText?: boolean;
}

/**
 * Equal Housing Opportunity mark (house outline with equal sign),
 * rendered inline as SVG so it inherits the surrounding text color.
 */
export function EqualHousingLogo({ className, size = 28, showText = true }: EqualHousingLogoProps) {
  return (
    <span
      className={`inline-flex items-center gap-2 ${className ?? ""}`}
      role="img"
      aria-label="Equal Housing Opportunity"
    >
      <svg
        width={size}
        height={size}
        viewBox="0 0 64 64"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
        focusable="false"
      >
        <path
          d="M4 30 32 9l28 21"
          stroke="currentColor"
          strokeWidth="4"
          strokeLinecap="square"
          strokeLinejoin="miter"
        />
        <path
          d="M11 30v25h42V30"
          stroke="currentColor"
          strokeWidth="4"
          strokeLinejoin="miter"
        />
        <rect x="21" y="36" width="22" height="5" fill="currentColor" />
        <rect x="21" y="45" width="22" height="5" fill="currentColor" />
      </svg>
      {showText ? (
        <span className="text-[10px] font-semibold uppercase leading-tight tracking-wide">
          Equal Housing
          <br />
          Opportunity
        </span>
      ) : null}
    </span>
  );
}
